module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [(_vm.active == 0) ? _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位名称",
      "prop": "danwei",
      "rules": [{
        required: true,
        message: '单位名称不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "kaojitype",
      "rules": [{
        required: true,
        message: '请选择类型',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.kaojitype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "kaojitype", $$v)
      },
      expression: "formData.kaojitype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '考级中心'
    }
  }, [_vm._v("考级中心")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '考级点'
    }
  }, [_vm._v("考级点")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.formData.kaojitype == '考级中心') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考级中心类型",
      "prop": "kaoji_jiameng_type",
      "rules": [{
        required: true,
        message: '请选择考级中心类型'
      } ]
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.kaoji_jiameng_type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "kaoji_jiameng_type", $$v)
      },
      expression: "formData.kaoji_jiameng_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '4'
    }
  }, [_vm._v("指定考级中心（投入成本12万元）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '5'
    }
  }, [_vm._v("样板考级中心（投入成本13.5万元）")])], 1)], 1)], 1) : _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考级点类型",
      "prop": "kaoji_jiameng_type",
      "rules": [{
        required: true,
        message: '请选择考级点类型'
      } ]
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.kaoji_jiameng_type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "kaoji_jiameng_type", $$v)
      },
      expression: "formData.kaoji_jiameng_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("指定考级点（投入成本0元）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '3'
    }
  }, [_vm._v("样板考级点（投入成本9800元）")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位执照",
      "prop": "zhizhaopic"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.zhizhaopic,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传营业执照 或 法人证书 或 组织结构代码证")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地区选择",
      "prop": "area",
      "rules": [{
        required: true,
        message: '请选择地区',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address",
      "rules": [{
        required: true,
        message: '请输入详细地址',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("负责人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "nickname",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.validator.phone,
        message: '请输入正确的手机号',
        trigger: ['blur', 'change']
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("日常联系人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "contactsname",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.contactsname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsname", $$v)
      },
      expression: "formData.contactsname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "contactsphone",
      "rules": [{
        required: true,
        validator: _vm.validator.phone,
        message: '请输入正确的手机号',
        trigger: ['blur', 'change']
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.contactsphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsphone", $$v)
      },
      expression: "formData.contactsphone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active == 1 || _vm.active == 2) ? _c('div', {
    staticClass: "step-three"
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmitThree,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('div', {
    staticClass: "step-three-title"
  }, [_vm._v("确认验收信息")]), _vm._v(" "), _c('div', {
    staticClass: "step-three-content"
  }, [_c('div', [_vm._v("请确认您的创建清单：")]), _vm._v(" "), _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v(_vm._s(_vm.formData.danwei) + " （" + _vm._s(_vm.formData.kaojitype) + "）")]), _vm._v(" "), (_vm.formData.kaoji_jiameng_type == 2) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("0元")]) : (_vm.formData.kaoji_jiameng_type == 3) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("9800元")]) : (_vm.formData.kaoji_jiameng_type == 4) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("12万元")]) : (_vm.formData.kaoji_jiameng_type == 5) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("13.5万元")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "请下载文化布置，发至广告公司制作"
    }
  }), _vm._v(" "), (_vm.formData.kaojitype == '考级点') ? _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('div', {
    staticClass: "dialog-step-li-text"
  }, [_c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download({
          name: '考级点文化包（兼容版）',
          url: 'https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip'
        })
      }
    }
  }, [_vm._v("考级点文化包（兼容版）请下载制作")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.formData.kaojitype == '考级中心') ? _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('div', {
    staticClass: "dialog-step-li-text"
  }, [_c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download({
          name: '考级中心文化包（兼容版）',
          url: 'https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip'
        })
      }
    }
  }, [_vm._v("考级中心文化包（兼容版）请下载制作")])], 1)]) : _vm._e(), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "请上传现场文化布置图"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.kaoji_yanshoufile,
      "limit": 5,
      "name": 'kaoji_yanshoufile'
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    on: {
      "click": _vm.onPay
    }
  }, [_vm._v("我要付款")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSubmitThree
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showPay,
      "title": "收款账户",
      "show-confirm-button": false,
      "close-on-click-overlay": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showPay = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "text-align": "center",
      "margin": "0px auto 20px",
      "font-size": "14px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://bc2026.oss-ap-southeast-1.aliyuncs.com/uploader/000/user-xxx/vc-upload-1625623675743-3.jpeg"
    }
  })])]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "visible": _vm.contactShow,
      "title": "联系人信息",
      "show-cancel-button": false,
      "close-on-click-overlay": true
    },
    on: {
      "update:visible": function($event) {
        _vm.contactShow = $event
      },
      "close": _vm.onContactClose
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "margin": "0px auto 20px"
    }
  }, [_c('div', [_vm._v("姓名：" + _vm._s(_vm.contactRow.name))]), _vm._v(" "), _c('div', [_vm._v("电话："), _c('a', {
    staticStyle: {
      "color": "#409eff"
    },
    attrs: {
      "href": 'tel:' + _vm.contactRow.phone
    }
  }, [_vm._v(_vm._s(_vm.contactRow.phone))])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2bae502","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/StationApplyMine.vue
// module id = 1535
// module chunks = 0